import axios, { InternalAxiosRequestConfig } from 'axios';
import { API_TIMEOUT } from '../../APIConstants';
import { AUTHORIZATION_HEADER_ID, DEFAULT_BEARER_AUTH_SCHEME } from '../../utils/HeaderUtils';

interface MutableRefObject<T> {
  current: T;
}

export const awSensitiveDataSettings: {
  getIsJwtTokenRequired: () => boolean;
  getJwtTokenRef?: MutableRefObject<(() => string) | undefined>;
} = {
  getIsJwtTokenRequired: () => false,
  getJwtTokenRef: undefined,
};

export const awSensitiveDataApi = axios.create();

export const interceptorFunction = function (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
  const { getIsJwtTokenRequired, getJwtTokenRef } = awSensitiveDataSettings;
  const updatedConfig: InternalAxiosRequestConfig = {
    ...config,
    timeout: API_TIMEOUT,
    params: {
      ...config.params,
    },
  };
  // If withCredentials is explicitly set to false, we should not add the JWT token to the request headers.
  if (getIsJwtTokenRequired() && updatedConfig.withCredentials !== false) {
    if (getJwtTokenRef?.current) {
      const jwtTokenValue = getJwtTokenRef.current();
      updatedConfig.headers[AUTHORIZATION_HEADER_ID] = `${DEFAULT_BEARER_AUTH_SCHEME} ${jwtTokenValue}`;
    } else {
      console.error('JWT token request header is enabled, but token is unavailable');
    }
  }
  return updatedConfig;
};

awSensitiveDataApi.interceptors.request.use(interceptorFunction);
